import { BasePathProvider, useBasePath } from "components/Providers";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AssignSubForm from "./AssignSubForm";
import { get } from "store/substitute/substitute-portal";
import SubstitutePortalFormSkeleton from "./FormSkeleton";

export default function SubstituteFormIndex({ date }) {
    const { id } = useParams();
    const basePath = useBasePath();
    const dispatch = useDispatch();
    const [record, setRecord] = useState(null);


    useEffect(() => {
        dispatch(get({ personId: id, date }))
            .then(res => setRecord(res.payload))
            .catch(() => setRecord(null))

    }, [id, dispatch,]);

    if (!record) {
        return <SubstitutePortalFormSkeleton />;
    }

    return (
        <BasePathProvider value={basePath}>
            <AssignSubForm date={date} record={record} />
        </BasePathProvider>
    )

}

